import axios from "../axios";

export async function fetchVehicleInsurances(params) {
  return axios({ method: "get", url: "/vehicle_insurances", params })
    .then((r) => r.data)
    .catch((e) => e.response?.data || e);
}

export async function createVehicleInsurance(payload) {
  return axios
    .post("/vehicle_insurances", { vehicle_insurance: payload })
    .then((r) => r.data)
    .catch((e) => e);
}

export async function updateVehicleInsurance(payload) {
  return axios
    .put(`/vehicle_insurances/${payload.id}`, { vehicle_insurance: payload })
    .then((r) => r.data)
    .catch((e) => e);
}

export async function deactivateVehicleInsurance(id, end_date) {
  return axios
    .put(`/vehicle_insurances/${id}/deactivate`, { end_date })
    .then((r) => r.data)
    .catch((e) => e);
}


